<template>
  <v-sheet class="appointment-card" outlined rounded="lg">
    <div class="appointment-card__top">
      <div class="appointment-card__time">
        <v-icon small class="mr-1">mdi-clock-outline</v-icon>
        {{ timeRange }}
      </div>
      <v-chip x-small :color="statusMeta.color" :text-color="statusMeta.textColor">
        {{ statusMeta.label }}
      </v-chip>
    </div>

    <div class="appointment-card__service">{{ appointment.service_type_name }}</div>
    <div class="appointment-card__guest">
      {{ appointment.guest_first_name }} {{ appointment.guest_last_name }}
      <span v-if="appointment.guest_email" class="grey--text"> · {{ appointment.guest_email }}</span>
    </div>
    <div v-if="appointment.telegram_username" class="appointment-card__telegram grey--text text--darken-1">
      Telegram: {{ appointment.telegram_username }}
    </div>
    <div v-if="appointment.conference_url" class="appointment-card__conference">
      <a :href="appointment.conference_url" target="_blank" rel="noopener noreferrer">{{ appointment.conference_url }}</a>
    </div>

    <div v-if="appointment.status === 'pending'" class="appointment-card__actions">
      <v-text-field
        v-model="conferenceUrl"
        placeholder="Ссылка на конференцию (необязательно)"
        outlined
        dense
        hide-details
        class="mb-2"
      />
      <div class="d-flex">
        <v-btn small color="#009E60" dark class="mr-2" :loading="loading" @click="$emit('accept', { id: appointment.id, conference_url: conferenceUrl })">
          Подтвердить
        </v-btn>
        <v-btn small outlined color="#EC2E2E" :loading="loading" @click="$emit('decline', appointment.id)">
          Отклонить
        </v-btn>
      </div>
    </div>

    <div v-else-if="appointment.status === 'confirmed'" class="appointment-card__actions">
      <v-btn small outlined color="#483CB9" :loading="loading" @click="$emit('edit-conference-link', appointment)">
        {{ appointment.conference_url ? 'Изменить ссылку' : 'Добавить ссылку' }}
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
import { utcToLocalTime } from '@/common/calendarTime';

const STATUS_META = {
  pending: { label: 'Ожидает подтверждения', color: '#fff4e0', textColor: '#B26A00' },
  confirmed: { label: 'Подтверждена', color: '#e3f6ec', textColor: '#009E60' },
  declined: { label: 'Отклонена', color: '#fdecec', textColor: '#EC2E2E' },
  cancelled_by_guest: { label: 'Отменена клиентом', color: '#f0f0f0', textColor: '#666' },
};

export default {
  name: 'AppointmentCard',
  props: {
    appointment: { type: Object, required: true },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      conferenceUrl: this.appointment.conference_url || '',
    };
  },
  watch: {
    // Компонент переиспользуется при перезагрузке списка (тот же :key),
    // поэтому синхронизируем локальное поле с обновлённым значением из стора.
    'appointment.conference_url': function onConferenceUrlChange(value) {
      this.conferenceUrl = value || '';
    },
  },
  computed: {
    timeRange() {
      return `${utcToLocalTime(this.appointment.scheduled_starts_at)} – ${utcToLocalTime(this.appointment.scheduled_ends_at)}`;
    },
    statusMeta() {
      return STATUS_META[this.appointment.status] || { label: this.appointment.status, color: '#f0f0f0', textColor: '#666' };
    },
  },
};
</script>

<style lang="scss" scoped>
.appointment-card {
  padding: 12px;
  margin-bottom: 12px;

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  &__time {
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 500;
  }

  &__service {
    font-size: 14px;
    font-weight: 600;
  }

  &__guest {
    font-size: 12px;
    margin: 2px 0;
  }

  &__telegram, &__conference {
    font-size: 12px;
    margin-bottom: 4px;
  }

  &__actions {
    margin-top: 8px;
  }
}
</style>
